import {KilnInfo} from '@domain/kiln-monitoring'
import {ApiClient} from '@hconnect/apiclient'
import type {HttpError} from '@hconnect/common/types'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import type {AxiosError} from 'axios'

const QueryKeyPrefix = 'kilns-info'
const STALE_TIME_IN_MS = 1000 * 60 * 60

export const useGetKilnsInfo = (
  plantId?: string,
  options?: Omit<UseQueryOptions<KilnInfo[], AxiosError<HttpError>>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<KilnInfo[], AxiosError<HttpError>>({
    queryKey: [QueryKeyPrefix, plantId],
    queryFn: async ({signal}) => {
      const path = `/kms/${plantId}/kilns`
      const response = await ApiClient.axiosInstance.get<KilnInfo[]>(path, {signal})

      return response.data
    },
    staleTime: STALE_TIME_IN_MS,
    refetchOnWindowFocus: false,
    ...options
  })
}
